import _ from 'underscore';

import {RequestTaskSchema} from '../tasks/RequestTaskConstants';

export default function sortRequestTaskSchemas(
  requestTaskSchemas: Array<RequestTaskSchema>
): Array<RequestTaskSchema> {
  return _.sortBy(requestTaskSchemas, (schema) => schema.name.toLocaleLowerCase());
}
